import {
    Card,
    CardBody,
    Typography,
    Select,
    Option,
    Button,
    Dialog
} from "@material-tailwind/react";
import { useState } from "react";
import { useStore } from "../store/Zustand";
import { useAuth } from "../store/auth";
import { useNavigate } from "react-router";
import { UPDATE_REFILL_STATUS } from "../Constants";
import axios from "../api/axios";
import { faBackward, faForward, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";

// const TABLE_HEAD = ["Id", "Name", "Start Date", "End Date", "Mobile", "Alert Date", "Tenure", "Actions"];
const TABLE_HEAD = [
    { label: "Order ID", className: "" },
    { label: "First Name", className: "" },
    { label: "Last Name", className: "" },
    { label: "Next Start Date", className: "sm:hidden md:table-cell lg:table-cell" },
    // { label: "End Date", className: "sm:hidden md:table-cell lg:table-cell" },
    { label: "Phone", className: "sm:hidden md:table-cell lg:table-cell" },
    { label: "Alert Date", className: "" },
    { label: "Tenure", className: "sm:hidden md:table-cell lg:table-cell" },
    { label: "Action", className: "sm:hidden md:table-cell lg:table-cell" }
];

export default function RefillData() {

    const token = useAuth((state) => state.token);
    const resetAuth = useAuth((state) => state.resetAuth);

    const refills = useStore((state) => state.refills);

    const refill_list = useStore((state) => state.refill_list);
    // const setRefillList = useStore((state) => state.setRefillList);

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);

    const getStatusColorClass = (status) => {
        switch (parseInt(status)) {
            case 0: // Unprocessed
                return "bg-orange-100 border border-gray-400";
            case 1: // Snooze
                return "bg-yellow-100 border border-gray-400";
            case 2: // Confirm
                return "bg-blue-100 border border-gray-400";
            case 3: // Dispatched
                return "bg-green-100 border border-gray-400";
            case 4: // Stop
                return "bg-red-100 border border-gray-400";
            default:
                return "border border-gray-400";
        }
    };

    const setRefillStatus = useStore((state) => state.setRefillStatus);

    const navigate = useNavigate();

    const currentPage = useStore((state) => state.currentPage);
    const setCurrentPage = useStore((state) => state.setCurrentPage);
    const totalPages = useStore((state) => state.totalPages);

    const handleRefillStatus = async (e, data) => {
        const newStatus = parseInt(e.target.value);
        const carefillId = data.carefill_id;

        setRefillStatus(carefillId, newStatus);

        try {
            if (token !== "" && refill_list !== "") {
                const reqData = {
                    carefill_id: carefillId,
                    carefill_status: newStatus,
                };

                const response = await axios.patch(UPDATE_REFILL_STATUS, reqData, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-tokens": token,
                    },
                });
                // console.log("req data:", reqData)
                // if (response.status !== 201) {
                //     alert(response.data.status_message);
                // }
                if (response.status === 201) {
                    // console.log(response)
                } else {
                    alert(response.data.status_message)
                }
            }
            else if (token !== "" && refill_list === "") {
                alert("please provide a valid value")
            }
        }
        catch (err) {
            if (err?.response?.data?.status_message) {
                alert(err?.response?.data?.status_message);
            } else if (err.response.status === 500) {
                alert(err.response.data.status_message);
            } else if (err.response.status === 400) {
                alert(err.response.data.status_message);
            } else if (err.response.status === 403) {
                alert(err.response.data.status_message)
                resetAuth()
                navigate("/generateOTP")
            } else {
                alert(err.response.data.status_message);
            }
            setRefillStatus(carefillId, data.carefill_status);
        }

    }
    useEffect(() => {
        if (selectedRowData) {
            const updated = refill_list.find(
                (item) => item.carefill_id === selectedRowData.carefill_id
            );
            if (updated) setSelectedRowData(updated);
        }
    }, [refill_list]);

    return (
        <>
            <div className="w-full lg:px-10 md:px-10 sm:px-5 py-5 overscroll-y-auto overscroll-x-auto">
                {/* <Card className="overflow-scroll h-full w-full"></Card> */}
                <Card className="h-full w-full">
                    <table className="w-full min-w-max table-auto text-center">
                        <thead>
                            <tr>
                                {TABLE_HEAD.map((head) => (
                                    <th
                                        key={head}
                                        // className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                                        className={`border-b border-blue-gray-100 bg-blue-gray-50 p-[5px] ${head.className}`}
                                    >
                                        {/* <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal leading-none opacity-70"
                                        > */}
                                        <Typography variant="small"
                                            color="blue-gray"
                                            className="font-normal opacity-70 overflow-hidden text-ellipsis"
                                        >
                                            {head.label}
                                        </Typography>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {/* {[...refill_list]
                                .sort((a, b) => new Date(a.alert_date) - new Date(b.alert_date))
                                .map((data, index) => { */}
                            {refill_list.map(
                                // ({ carefill_id, first_name, carefill_start_date, carefill_end_date, mobile_number, alert_date, refill_cycle }, index) => {
                                (data, index) => {
                                    const isLast = index === refills.length - 1;
                                    const classes = isLast
                                        ? "p-2"
                                        : "p-2 border-b border-blue-gray-50";
                                    // p-4
                                    return (
                                        <tr
                                            key={index}
                                            className={`
                                            ${parseInt(data.carefill_status) === 0 ? 'sm:bg-orange-100 md:bg-transparent lg:bg-transparent' : ''}  // Unprocessed
                                            ${parseInt(data.carefill_status) === 1 ? 'sm:bg-yellow-100 md:bg-transparent lg:bg-transparent' : ''}  // Snooze
                                            ${parseInt(data.carefill_status) === 2 ? 'sm:bg-blue-100 md:bg-transparent lg:bg-transparent' : ''}    // Confirm
                                            ${parseInt(data.carefill_status) === 3 ? 'sm:bg-green-100 md:bg-transparent lg:bg-transparent' : ''}   // Dispatched
                                            ${parseInt(data.carefill_status) === 4 ? 'sm:bg-red-100 md:bg-transparent lg:bg-transparent' : ''}     // Stop
                                            `}
                                            onClick={() => {
                                                if (window.innerWidth < 768) {
                                                    setSelectedRowData(data);
                                                    setOpenDialog(true);
                                                }
                                            }}
                                        >
                                            <td
                                                className={classes}
                                            // className={`${classes} sm:hidden md:table-cell lg:table-cell`}
                                            >
                                                <Typography
                                                    variant="paragraph"
                                                    color="blue-gray"
                                                    className="font-normal text-sm"
                                                // lg:text-sm md:text-sm sm:text-[12px]
                                                >
                                                    {data.order_id}
                                                </Typography>
                                            </td>
                                            <td className={classes}>
                                                <Typography
                                                    variant="paragraph"
                                                    color="blue-gray"
                                                    className="font-normal text-sm"
                                                >
                                                    {data.first_name}
                                                </Typography>
                                            </td>
                                            <td className={classes}>
                                                <Typography
                                                    variant="paragraph"
                                                    color="blue-gray"
                                                    className="font-normal text-sm"
                                                >
                                                    {data.last_name}
                                                </Typography>
                                            </td>
                                            {/* <td
                                                // className={classes}
                                                className={`${classes} sm:hidden md:table-cell lg:table-cell`}
                                            >
                                                <Typography
                                                    variant="paragraph"
                                                    color="blue-gray"
                                                    className="font-normal text-sm"
                                                >
                                                    {data.carefill_start_date}
                                                </Typography>
                                            </td>
                                            <td
                                                className={`${classes} sm:hidden md:table-cell lg:table-cell`}
                                            >
                                                <Typography
                                                    variant="paragraph"
                                                    color="blue-gray"
                                                    className="font-normal text-sm"
                                                >
                                                    {data.carefill_end_date}
                                                </Typography>
                                            </td> */}
                                            <td
                                                className={`${classes} sm:hidden md:table-cell lg:table-cell`}
                                            >
                                                <Typography
                                                    variant="paragraph"
                                                    color="blue-gray"
                                                    className="font-normal text-sm"
                                                >
                                                    {data.next_start_date}
                                                </Typography>
                                            </td>
                                            <td
                                                className={`${classes} sm:hidden md:table-cell lg:table-cell`}
                                            >
                                                <Typography
                                                    variant="paragraph"
                                                    color="blue-gray"
                                                    className="font-normal text-sm"
                                                >
                                                    {data.mobile_number}
                                                </Typography>
                                            </td>
                                            <td className={classes}>
                                                <Typography
                                                    variant="paragraph"
                                                    color="blue-gray"
                                                    className="font-normal text-sm"
                                                >
                                                    {data.alert_date}
                                                </Typography>
                                            </td>
                                            <td
                                                className={`${classes} sm:hidden md:table-cell lg:table-cell`}
                                            >
                                                <Typography
                                                    variant="paragraph"
                                                    color="blue-gray"
                                                    className="font-normal text-sm"
                                                >
                                                    {data.refill_cycle}
                                                </Typography>
                                            </td>
                                            <td
                                                className={`${classes} sm:hidden md:table-cell lg:table-cell`}
                                            >
                                                <div className="flex flex-row justify-between text-start items-start w-[135px]">
                                                    <Select
                                                        size="md"
                                                        label="Select Status"
                                                        color="blue"
                                                        value={String(data.carefill_status ?? "")}
                                                        className={getStatusColorClass(data.carefill_status)}
                                                        onChange={(value) => {
                                                            handleRefillStatus({ target: { value } }, data);
                                                        }}
                                                    >
                                                        <Option value="0">Unprocessed</Option>
                                                        <Option value="1">Snooze</Option>
                                                        <Option value="2">Confirm</Option>
                                                        <Option value="3">Dispatched</Option>
                                                        <Option value="4">Stop</Option>
                                                    </Select>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                }
                            )}
                        </tbody>
                    </table>
                    {refill_list.length > 0 ? (
                        <></>
                    ) : (
                        <Card className="mt-6 w-full text-center">
                            <CardBody>
                                <Typography variant="h4" color="blue-gray" className="mb-2">
                                    No records found
                                </Typography>
                            </CardBody>
                        </Card>
                    )}
                </Card>
                <Dialog
                    open={openDialog}
                    handler={() => setOpenDialog(false)}
                    size="xs"
                    className="sm:block md:hidden lg:hidden"
                >
                    <div className="p-4 space-y-4">
                        <Typography variant="h5" color="blue-gray">
                            Update Refill Status
                        </Typography>

                        {selectedRowData && (
                            <div className="space-y-2">
                                <Typography variant="small" className="font-bold text-gray-800">
                                    Order ID: {selectedRowData.order_id}
                                </Typography>

                                <Typography variant="small" className="font-bold text-gray-800">
                                    Name: {selectedRowData.first_name} {selectedRowData.last_name}
                                </Typography>

                                {/* <Typography variant="small" className="text-gray-800">
                                    <strong>Start Date:</strong> {selectedRowData.carefill_start_date}
                                </Typography>

                                <Typography variant="small" className="text-gray-800">
                                    <strong>End Date:</strong> {selectedRowData.carefill_end_date}
                                </Typography> */}

                                <Typography variant="small" className="text-gray-800">
                                    <strong>Next Start Date:</strong> {selectedRowData.next_start_date}
                                </Typography>

                                <Typography variant="small" className="text-gray-800">
                                    <strong>Alert Date:</strong> {selectedRowData.alert_date}
                                </Typography>

                                <Typography variant="small" className="text-gray-800">
                                    <strong>Phone:</strong> {selectedRowData.mobile_number}
                                </Typography>

                                <Typography variant="small" className="text-gray-800">
                                    <strong>Tenure:</strong> {selectedRowData.refill_cycle}
                                </Typography>

                                <Select
                                    size="md"
                                    label="Select Status"
                                    color="blue"
                                    value={String(selectedRowData?.carefill_status ?? "")}
                                    className={`w-full ${getStatusColorClass(selectedRowData?.carefill_status)}`}
                                    onChange={(value) => {
                                        handleRefillStatus({ target: { value } }, selectedRowData);
                                        setOpenDialog(false);
                                    }}
                                >
                                    <Option value="0">Unprocessed</Option>
                                    <Option value="1">Snooze</Option>
                                    <Option value="2">Confirm</Option>
                                    <Option value="3">Dispatched</Option>
                                    <Option value="4">Stop</Option>
                                </Select>

                            </div>
                        )}
                        {selectedRowData && (
                            <div className="absolute bottom-[17px] left-4 pt-4">
                                <Button color="blue" size="sm">
                                    <a href={`tel:${selectedRowData.mobile_number}`}>
                                        <FontAwesomeIcon icon={faPhone} size="lg" />
                                        <span className="ml-2">Call Us</span>
                                    </a>
                                </Button>
                            </div>
                        )}
                        <div className="flex bottom-[18px] justify-end pt-4">
                            <Button onClick={() => setOpenDialog(false)} color="red" size="sm">
                                Close
                            </Button>
                        </div>
                    </div>
                </Dialog>
                <div className="flex justify-center items-center gap-4 my-4">
                    <Button
                        size="sm"
                        onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
                        disabled={currentPage === 1}
                        color="blue"
                    >
                        <FontAwesomeIcon icon={faBackward} />
                    </Button>

                    <Typography variant="small">
                        Page {currentPage} of {totalPages}
                    </Typography>

                    <Button
                        size="sm"
                        onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        color="blue"
                    >
                        <FontAwesomeIcon icon={faForward} />
                    </Button>
                </div>
            </div >
        </>
    )
}